import type { Context, Value } from "@wildboar/meerkat-types";
import type { AttributeValue, ContextValue } from "@prisma/client";
import { ObjectIdentifier, BERElement } from "asn1-ts";

export
async function attributeFromDatabaseAttribute (
    ctx: Context,
    attr: AttributeValue & { ContextValue: ContextValue[] },
): Promise<Value> {
    const value = new BERElement();
    value.fromBytes(attr.ber);
    return {
        type: new ObjectIdentifier(attr.type.split(".").map((node) => Number.parseInt(node))),
        value,
        contexts: attr.ContextValue.map((c) => {
            const el = new BERElement();
            el.fromBytes(c.ber);
            return {
                contextType: ObjectIdentifier.fromString(c.type),
                fallback: c.fallback,
                contextValues: [ el ],
            };
        }),
    };
}

export default attributeFromDatabaseAttribute;
